const toRem = (px: number) => `${px / 16}rem`;

export const spacing = {
  none: "0",
  "2xs": toRem(2),
  xs: toRem(4),
  sm: toRem(6),
  md: toRem(8),
  lg: toRem(10),
  xl: toRem(12),
  "2xl": toRem(16),
  "3xl": toRem(20),
  "4xl": toRem(24),
  "5xl": toRem(32),
  "6xl": toRem(40),
  "7xl": toRem(48),
  "8xl": toRem(56),
  "9xl": toRem(64)
} as const;

export type Spacing = typeof spacing;
